/* eslint-disable */
const state = {

  // 身份认证信息
  certificationInfo:null,
  // 身份信息变更状态对应传值字段
  changeCertificationInfo: 1,
  time_w: null, // 站内信上一次时间戳
  websiteMes: [],
  analogueMobileMes: [], // 对手方手机号
  ownSideName: '', // 己方手机号
  myAssetBanks: [], // 可选择签约银行列表
  selectBank: null,// 已选择的签约银行
  bankId: null, // 已选择的开户银行id(信息申报)
  marketStatusInNewTopline: '--', // 新页面市场状态
  newRefreshSign: 0,// 新页面刷新按钮
  f10click: 0 // 点击f10
}

// getters
const getters = {
  ownSideNameGetter: state => state.ownSideName,
  analogueMobileMesGetter: (state) => state.analogueMobileMes,
  websiteMesGetter: (state) => state.websiteMes,
  time_wGetter: (state) => state.time_w,
  certificationInfoGetter(state) {
	    return state.certificationInfo
  },
  changeCertificationInfoGetter(state) {
    return state.changeCertificationInfo
  },
  myAssetBanksGetter(state) {
    return state.myAssetBanks
  },
  selectBank(state) {
    return state.selectBank
  },
  bankId(state) {
    return state.bankId
  },
  marketStatusInNewTopline(state) {
    return state.marketStatusInNewTopline
  },
  newRefreshSign(state) {
    return state.newRefreshSign
  },
  f10click(state) {
    return state.f10click
  }
}

// actions
const actions = {

}

// mutations
const mutations = {
  setOwnSideName(state, data) {
    state.ownSideName = data
  },
  setAnalogueMobileMes(state, data) {
    state.analogueMobileMes = data
  },
  setWebsiteMes(state, data) {
    state.websiteMes = data
  },
  setTime_w(state, data) {
    state.time_w = data
  },
  setCertificationInfo(state, data) {
	    state.certificationInfo = data
  },
  changeCertificationInfo(state, data) {
    state.changeCertificationInfo ++
  },
  myAssetBanks(state, data) {
    state.myAssetBanks = data
  },
  selectBank(state, data) {
    state.selectBank = data
  },
  bankId(state, data) {
    state.bankId = data
  },
  marketStatusInNewTopline(state, data) {
    state.marketStatusInNewTopline = data
  },
  newRefreshSign(state, data) {
    state.newRefreshSign++
  },
  f10click(state, data) {
    state.f10click++
  },

}

export default {
  state,
  getters,
  actions,
  mutations
}
